module.exports = __webpack_public_path__ + "static/img/slider66.31b37d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider66.png
// module id = 2Qha
// module chunks = 37